import React from "react";

/**
 * Placeholder for a component that allows the customer to preview the effective
 * config of the rig they've assembled.  Not yet implemented.
 */
export const RigPerformanceDetails: React.FC = () => {
  // return (
  //   <>
  //     <Card className="flex flex-col p-5 gap-5 rounded-xl min-h-40">
  //       <Typography className="text-lg">
  //         "{rig?.customerProvidedName}" performance details
  //       </Typography>
  //     </Card>
  //   </>
  // );

  return <></>;
};
